import React from "react";

const PoliticaDatos = () => {
  return (
    <>
      <section className="min-h-[70vh] bg-primario flex flex-col justify-center items-center text-center gap-6 sm:gap-8 px-4 sm:px-6 lg:px-8 py-24 sm:py-20 lg:py-28">
        <h1
          className="capitalize font-bold text-white leading-tight 
          text-[clamp(1.8rem,5vw,3rem)] 
          sm:w-5/6 md:w-2/3 lg:w-3/4 xl:w-2/3"
        >
          Política de <strong className="text-yellow-1">Privacidad</strong> y
          Tratamiento de{" "}
          <strong className="text-yellow-1">Datos Personales</strong>
        </h1>

        <p className="text-white text-xs sm:text-sm md:text-base max-w-xl">
          <strong className="text-yellow-1">
            Fecha de entrada en vigencia:
          </strong>{" "}
          01/01/2026 <br />
          <strong className="text-yellow-1">Última actualización:</strong>{" "}
          09/03/2026
        </p>
      </section>
      <div className="p-4 sm:px-6 sm:py-10 lg:px-8">
        <Section title="1. Introducción">
          <p>
            En Brighton Centro de Inglés protegemos tu información personal y
            garantizamos su tratamiento conforme a la legislación colombiana.
          </p>
        </Section>

        <Section title="2. Aplicación y Marco Legal">
          <p>
            Esta política cumple con la Constitución Política de Colombia,
            Permitiendo a los titulares el ejercicio efectivo de su derecho
            fundamental al Hábeas Data. Su alcance cubre los datos personales
            recolectados por Brighton en sus procesos presenciales, digitales,
            contractuales, académicos, administrativos y comerciales.
            <br />
            El marco normativo comprende el artículo 15 de la Constitución
            Política de Colombia, la Ley Estatutaria 1581 de 2012, el Decreto
            Reglamentario 1377 de 2013 y el Decreto Único Reglamentario 1074 de
            2015, entre otras normas aplicables. Esta política establece los
            principios, derechos, deberes y procedimientos relacionados con el
            tratamiento de datos personales en Brighton Centro de Inglés.
          </p>
        </Section>

        <Section title="3. Principios Generales">
          <p>
            Brighton garantiza la protección de los derechos de Hábeas Data,
            privacidad, intimidad, buen nombre e imagen. Todas las actuaciones
            relacionadas con información personal se rigen por los principios de
            buena fe, legalidad, libertad, transparencia, finalidad, veracidad,
            seguridad y confidencialidad, de manera que el tratamiento sea
            proporcional y compatible con la finalidad informada al titular.
          </p>
        </Section>

        <Section title="4. Definiciones Clave">
          <ul className="list-disc pl-6 space-y-1">
            <li>
              {" "}
              <strong>Autorización:</strong> Consentimiento previo, expreso e
              informado del titular para llevar a cabo el tratamiento de sus datos
              personales.
            </li>
            <li>
              {" "}
              <strong>Dato personal:</strong> Información que identifica a una
              persona
            </li>
            <li>
              {" "}
              <strong>Dato sensible:</strong> Información íntima o biométrica
            </li>
            <li>
              {" "}
              <strong>Dato Público:</strong> Dato como por ejemplo, información
              relativa al estado civil, profesión, oficio o calidad de comerciante
              o servidor público.
            </li>
            <li>
              {" "}
              <strong>Titular:</strong> Propietario de los datos
            </li>
            <li>
              {" "}
              <strong>Tratamiento:</strong> Uso de los datos
            </li>
            <li>
              {" "}
              <strong>Responsable:</strong> Brighton Centro de Inglés
            </li>
          </ul>
        </Section>
        <Section title="5. Principios del Tratamiento">
          <ul className="list-disc list-inside">
            <li>
              <strong>Legalidad:</strong> Tratamos los datos personales conforme a
              la normativa vigente y los derechos fundamentales.{" "}
            </li>
            <li>
              <strong>Libertad:</strong> Solo recolectamos y usamos datos con
              autorización previa, expresa e informada del titular, salvo
              obligación legal.
            </li>
            <li>
              <strong>Finalidad:</strong> Utilizamos los datos únicamente para
              propósitos legítimos previamente informados.
            </li>
            <li>
              <strong>Veracidad:</strong> Garantizamos que la información sea
              precisa, completa, actualizada y confiable.
            </li>
            <li>
              <strong>Transparencia:</strong> El titular puede conocer en
              cualquier momento qué datos tenemos y cómo los usamos.
            </li>
            <li>
              <strong>Acceso restringido:</strong> Protegemos los datos para
              evitar su acceso o divulgación no autorizada.
            </li>
            <li>
              <strong>Seguridad:</strong> Implementamos medidas técnicas y
              administrativas para proteger la información.
            </li>
            <li>
              <strong>Confidencialidad:</strong> Toda persona con acceso a los
              datos está obligada a mantener su reserva, incluso después de
              finalizar su relación con Brighton.
            </li>
          </ul>
        </Section>

        <Section title="6. Datos Sensibles y de Menores">
          <h3 className="font-bold">Datos Sensibles</h3>
          <p>
            Son aquellos que afectan la intimidad del titular, como información
            sobre salud, creencias, orientación política o datos biométricos
            (imágenes, huellas, reconocimiento facial, entre otros).
          </p>
          <br />
          <h3 className="font-bold">Tratamiento de datos sensibles</h3>
          <p>
            Brighton no recolecta datos sensibles de forma habitual. En caso de
            ser necesario, su tratamiento se realizará únicamente con autorización
            explícita, garantizando que el titular pueda decidir libremente si
            proporciona esta información.
          </p>
          <br />
          <h3 className="font-bold">Datos de niñas, niños y adolescentes</h3>
          <p>
            El tratamiento de datos personales de niños, niñas y adolescentes está
            prohibido, salvo cuando se trate de datos de naturaleza pública y el
            tratamiento respete el interés superior del menor y sus derechos
            fundamentales, de acuerdo con el artículo 12 de la Ley 1581 de 2012.{" "}
            <br />
            En Brighton, los datos de estudiantes que sean menores de edad se
            tratan exclusivamente para el desarrollo de la actividad educativa y
            administrativa. La autorización correspondiente debe ser otorgada por
            su representante legal, quien además actúa como canal principal de
            comunicación y como encargado de ejercer los derechos del menor.
          </p>
        </Section>

        <Section title="7. Uso para Marketing">
          <p>
            Se podrán usar fotos, videos y audios para promoción institucional,
            redes sociales, material educativo y testimonios orales o escritos,
            esta autorización se obtiene mediante la aceptación de la presente
            política.
          </p>
          <br />
          <p>
            El titular o su representante legal podrá solicitar la exclusión
            futura o el retiro de material existente mediante comunicación
            dirigida al Oficial de Protección de Datos. La solicitud se tramitará
            conforme al procedimiento de reclamos.
          </p>
        </Section>

        <Section title="8. Autorización y Consentimiento">
          La autorización se obtiene mediante formularios fisicos o digitales,
          casillas de verificación en linea, contratos laborales o de prestación
          de servicios, conservando evidencia de la autorización como soporte de
          trazabilidad.
        </Section>

        <Section title="9. Derechos del Titular">
          <ul className="list-disc pl-6 space-y-1">
            <li>Acceder a sus datos</li>
            <li>Actualizar o corregir</li>
            <li>Solicitar eliminación</li>
            <li>Revocar autorización</li>
            <li>Presentar quejas ante la SIC</li>
          </ul>
        </Section>

        <Section title="10. Deberes de Brighton">
          <p>
            Garantizar el derecho al Hábeas Data; Proteger, almacenar, actualizar
            y brindar la información de manera segura; Atender solicitudes y
            reclamos de manera oportuna y adoptar un manual interno de políticas y
            procedimientos para asegurar el cumplimiento de la ley y facilitar la
            atención de solicitudes.
          </p>
        </Section>

        <Section title="11. Procedimientos">
          Los titulares podrán ejercer sus derechos de consulta, reclamo,
          rectificación, actualización o supresión mediante comunicación dirigida
          al Oficial de Protección de Datos a través de los canales habilitados
          por Brighton.
          <br />
          <p>
            <strong>Consultas:</strong> El titular puede consultar la información
            personal que repose en nuestras bases de datos. La consulta será
            atendida en un término máximo de diez (10) días hábiles, contados a
            partir de la fecha de recibo. <br />
          </p>
          <p>
            <strong>Reclamos:</strong> Cuando el titular considere que la
            información debe ser corregida, actualizada, suprimida o que desea
            revocar autorizaciones, deberá presentar un reclamo que incluya:
            <br />
            <ol className="list-decimal list-inside">
              <li>Nombre e identificación del titular</li>
              <li>
                Descripción clara de los hechos y del derecho que desea ejercer.
              </li>
              <li>Datos de contacto para la respuesta.</li>
              <li>Documentos que soporten la solicitud.</li>
            </ol>
            El término para atender el reclamo será de quince (15) días hábiles,
            contados a partir del día siguiente a su recibo.
          </p>
        </Section>

        <Section title="12. Oficial de Protección de Datos">
          <p>
            En cumplimiento del Decreto 1074 de 2015, Brighton Centro de Inglés ha
            designado un Oficial de Protección de Datos encargado de supervisar el
            cumplimiento de esta política, asegurando el seguimiento de
            solicitudes, reclamos y requerimientos relacionados con el tratamiento
            de información personal.
          </p>
        </Section>

        <Section title="13. Aceptación">
          <p>
            El titular, al proporcionar sus datos personales a Brighton Centro de
            Inglés por cualquier medio físico o digital, manifiesta que ha leído,
            entendido y aceptado los términos de la presente Política de
            Privacidad y Tratamiento de Datos Personales, otorgando su
            autorización libre, expresa e informada para el tratamiento de sus
            datos conforme a las finalidades descritas.
          </p>
        </Section>

        <Section title="14. Contacto">
          <p>
            Para consultas, solicitudes, reclamos o el ejercicio de derechos
            relacionados con la protección de datos personales, el titular puede
            comunicarse con el Oficial de Protección de Datos a través de los
            siguientes medios:
          </p>
          <ul className="list-disc list-inside">
            <li>Correo: contactos@brightonenglishcenter.edu.co</li>
            <li>Dirección: Carrera 38 #19-26, Pasto</li>
            <li>Teléfono oficina principal: (602) 721 07 51</li>
          </ul>
        </Section>

      </div>
    </>
  );
};

const Section = ({ title, children }) => (
  <section
    className="max-w-3xl lg:max-w-4xl xl:max-w-5xl 
    mx-auto 
    py-6 sm:py-8 
    [&:not(:last-child)]:border-b 
    [&:not(:last-child)]:border-gray-300"
  >
    <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-primario">{title}</h2>
    <div className="text-sm sm:text-base md:text-[1.05rem] leading-relaxed space-y-3">{children}</div>
  </section>
);

export default PoliticaDatos;
